module.exports = __webpack_public_path__ + "42f19c112a5f89288fbbcd1346defa52.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-27.png
// module id = 1642
// module chunks = 0